import React, { useRef, useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import DownloadIcon from "@material-ui/icons/CloudDownload";

export const FacturaZoomViewer = ({
  facturaUrl,
  facturaUrls,
  abrirImagenEnNuevaPestana
}) => {
  const containerRef = useRef(null);
  const imgRef = useRef(null);
  const [setTransformFn, setSetTransformFn] = useState(null);
  const urls = (facturaUrls && facturaUrls.length
    ? facturaUrls
    : [facturaUrl]
  ).filter(Boolean);
  const [activeIndex, setActiveIndex] = useState(0);
  const activeUrl = urls[activeIndex] || urls[0];
  const INITIAL_SCALE = 0.55;
  const INITIAL_OFFSET_X = 150;
  const INITIAL_OFFSET_Y = 175;

  const calculateAndCenterImage = () => {
    if (!containerRef.current || !imgRef.current || !setTransformFn) return;
    setTransformFn(INITIAL_OFFSET_X, INITIAL_OFFSET_Y, INITIAL_SCALE);
  };

  useEffect(
    () => {
      if (imgRef.current && imgRef.current.complete) {
        calculateAndCenterImage();
      }
    },
    [setTransformFn, activeUrl]
  );

  if (!activeUrl) {
    return (
      <Grid item xs={12} style={{ minHeight: "480px" }}>
        No hay imagen de factura disponible.
      </Grid>
    );
  }

  return (
    <Grid
      item
      xs={12}
      ref={containerRef}
      style={{
        height: "480px",
        maxWidth: "640px",
        overflow: "hidden",
        border: "1px solid #e0e0e0",
        position: "relative",
        borderRadius: "4px"
      }}
    >
      <TransformWrapper
        minScale={INITIAL_SCALE}
        limitToBounds={true}
        wheel={{ disabled: false }}
        panning={{ disabled: false }}
        doubleClick={{ disabled: true }}
        onInit={({ setTransform }) => {
          setSetTransformFn(() => setTransform);
        }}
        onZoomStop={({ state, setTransform }) => {
          // Si el zoom llegó al mínimo, aseguramos el centrado correcto
          const { scale } = state;
          if (scale <= INITIAL_SCALE + 0.001) {
            setTransform(INITIAL_OFFSET_X, INITIAL_OFFSET_Y, INITIAL_SCALE);
          }
        }}
      >
        {({ zoomIn, zoomOut }) => (
          <>
            <TransformComponent
              wrapperStyle={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <img
                ref={imgRef}
                src={activeUrl}
                alt="Factura"
                onLoad={calculateAndCenterImage}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  cursor: "grab"
                }}
              />
            </TransformComponent>

            {/* Controles */}
            <div style={{ position: "absolute", bottom: 20, right: 20 }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: "0.5em" }}
                onClick={() => zoomIn()}
              >
                +
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: "0.5em" }}
                onClick={() => zoomOut()}
              >
                -
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={calculateAndCenterImage}
              >
                Reset
              </Button>
            </div>

            {/* Botón de descarga */}
            <div style={{ position: "absolute", top: 20, right: 20 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => abrirImagenEnNuevaPestana(activeUrl)}
              >
                <DownloadIcon />
              </Button>
            </div>
          </>
        )}
      </TransformWrapper>
      {urls.length > 1 && (
        <div
          style={{
            position: "absolute",
            bottom: 75,
            left: 10,
            right: 10,
            display: "flex",
            gap: 8,
            overflowX: "auto"
          }}
        >
          {urls.map((url, index) => (
            <button
              type="button"
              key={url}
              onClick={() => setActiveIndex(index)}
              style={{
                border:
                  index === activeIndex
                    ? "2px solid #ff9800"
                    : "1px solid #ddd",
                padding: 2,
                background: "white",
                cursor: "pointer"
              }}
            >
              <img
                src={url}
                alt={`Factura ${index + 1}`}
                style={{ height: 48, maxWidth: 72 }}
              />
            </button>
          ))}
        </div>
      )}
    </Grid>
  );
};
